export const WEEKDAY_KEYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

export function toDateKey(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function weekdayKeyOf(date) {
  return WEEKDAY_KEYS[date.getDay()];
}

export function addDays(date, amount) {
  const next = new Date(date);
  next.setDate(next.getDate() + amount);
  return next;
}

export function startOfWeek(date) {
  return addDays(date, -date.getDay());
}

export function startOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

export function buildMonthGrid(date) {
  const gridStart = startOfWeek(startOfMonth(date));
  const weeks = [];
  let cursor = gridStart;
  for (let w = 0; w < 6; w++) {
    const week = [];
    for (let d = 0; d < 7; d++) {
      week.push(cursor);
      cursor = addDays(cursor, 1);
    }
    weeks.push(week);
  }
  return weeks;
}

export function buildWeekRow(date) {
  const start = startOfWeek(date);
  return Array.from({ length: 7 }, (_, i) => addDays(start, i));
}

export function isSameDay(a, b) {
  return toDateKey(a) === toDateKey(b);
}

export function isPastDate(date, today = new Date()) {
  return toDateKey(date) < toDateKey(today);
}

// Slots more than this many days out haven't been created/planned yet, so the
// calendar locks them the same way it locks past days.
export const FUTURE_SLOT_WINDOW_DAYS = 30;

export function isFutureLockedDate(date, today = new Date(), days = FUTURE_SLOT_WINDOW_DAYS) {
  return toDateKey(date) > toDateKey(addDays(today, days));
}

export function isSameMonth(a, b) {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth();
}

export function formatMonthLabel(date) {
  return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
}

export function formatWeekLabel(date) {
  const days = buildWeekRow(date);
  const startLabel = days[0].toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  const endLabel = days[6].toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  return `${startLabel} – ${endLabel}`;
}

export function formatDayLabel(date) {
  return date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
}

export function weekdayShort(date) {
  return date.toLocaleDateString('en-US', { weekday: 'short' });
}
